// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { BULK_EDITS_FILTER } from 'components/BulkUpdates/constants'
import { initialFrequencyPlanValues } from 'redux/modules/pathDetails'

// makes initial values for the bulk edit - path mode form.

const makeBulkUpdatePathModeInitialValues = () => (dispatch, getState) => {
  // the only value that doesn't initialize empty is the band id.
  // this defaults to whatever is selected in the bulk edits filter
  const { bandId } = getState().form[BULK_EDITS_FILTER].values

  const jobCode = ''
  const rcnNumber = ''

  // although initialFrequencyPlanValues has some fields we don't
  // use in bulk edits, using the same initial values as on Path Details
  // allows us to re-use the Path Details frequency lookup and
  // business logic for this section in Bulk Edits
  const frequencyPlans = [
    { ...initialFrequencyPlanValues },
    { ...initialFrequencyPlanValues },
  ]

  return {
    bandId,
    frequencyPlans,
    jobCode,
    rcnNumber,
  }
}

export default makeBulkUpdatePathModeInitialValues
